import { Field, Int, ObjectType } from '@nestjs/graphql'
import { ArcDto, BookDto } from 'booksprout'
import { ArcClaimDto } from './model.dto'

@ObjectType()
export class ClaimEligibilityStatusDto {
  @Field(t => Int)
  ineligibleReason!: number

  @Field({ nullable: true })
  reasonDate?: Date

  @Field({ nullable: true })
  reasonDescription?: string

  @Field(type => ArcDto, { nullable: true })
  suggestedArc?: ArcDto

  @Field(type => [BookDto], { nullable: true })
  suggestedBooks?: BookDto[]

  @Field(type => ArcClaimDto, { nullable: true })
  existingClaim?: ArcClaimDto
}
